module.exports = __webpack_public_path__ + "img/cornice.a2e7496e.jpg";